import * as coreComponents from './core'
import deviceMedia from './device'

export const device = deviceMedia

export const core = coreComponents
